import { Head, Link, router } from '@inertiajs/react'
import { Badge, Box, Button, Card, Flex, Heading, Separator, Text } from '@radix-ui/themes'
import { badgeColors } from '@/shared/constants/constants'
import { ApplicationsManageApplication, ApplicationsManageProps } from '@/types/applications_manage'

export default function ApplicationsManage({ email, applications }: ApplicationsManageProps) {
  return (
    <>
      <Head title="Manage applications" />
      <Box style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        <Heading size="7">Your applications</Heading>
        <Flex justify="between" align="center" gap="3" wrap="wrap">
          <Text size="3" color="gray" as="p">
            Signed in via the link sent to <strong>{email}</strong>.
          </Text>
          <a href={`/users/sign_up?email=${encodeURIComponent(email)}`} className="text-accent9">
            Create an account
          </a>
        </Flex>
        <Separator my="4" size="4" />

        {applications.length === 0 ? (
          <Text color="gray">No applications on file for this email.</Text>
        ) : (
          <Flex direction="column" gap="4">
            {applications.map((app) => (
              <ApplicationCard key={app.id} application={app} />
            ))}
          </Flex>
        )}
      </Box>
    </>
  )
}

function ApplicationCard({ application }: { application: ApplicationsManageApplication }) {
  const canWithdraw = application.status !== 'rejected' && application.status !== 'withdrawn'

  const handleWithdraw = () => {
    if (!confirm(`Withdraw your application for ${application.event.name}?`)) return
    router.delete(application.withdraw_path)
  }

  return (
    <Card>
      <Flex justify="between" align="start" gap="4">
        <Box>
          <Heading size="5">
            <Link href={application.event.path}>{application.event.name}</Link>
          </Heading>
          <Text size="2" color="gray" as="p">
            Applying as <strong>{application.participant.type_name ?? 'participant'}</strong> ({application.participant.name})
          </Text>
          {application.event.date && (
            <Text size="2" color="gray" as="p">
              Event date: {application.event.date}
            </Text>
          )}
        </Box>
        <Flex direction="column" align="end" gap="2">
          <Badge color={badgeColors[application.status]} size="2">
            {application.status}
          </Badge>
          {canWithdraw && (
            <Button color="red" variant="soft" size="2" onClick={handleWithdraw}>
              Withdraw
            </Button>
          )}
        </Flex>
      </Flex>
    </Card>
  )
}
